import client from './client';

export const getCandidateDashboard = () => client.get('/api/candidate-portal/dashboard');

export const listCandidateApplications = () => client.get('/api/candidate-portal/applications');

export const listCandidateInterviews = () => client.get('/api/candidate-portal/interviews');

export const listCandidateSchedules = () => client.get('/api/candidate-portal/schedules');

export const getCandidateProfile = () => client.get('/api/candidate-portal/profile');

export const uploadCandidateResume = (file) => {
  const form = new FormData();
  form.append('file', file);
  return client.post('/api/candidate-portal/resume', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const listCandidateOpenings = (params = {}) =>
  client.get('/api/candidate-portal/openings', { params });

export const applyToOpening = (openingId) =>
  client.post(`/api/candidate-portal/openings/${openingId}/apply`);

export const candidateTalentOptIn = (sessionCode) =>
  client.post('/api/candidate-portal/talent/opt-in', sessionCode ? { sessionCode } : {});

export const candidateTalentOptOut = () =>
  client.post('/api/candidate-portal/talent/opt-out');
